// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"265b930b","384":"38aa1cf8","394":"d235d0f1","459":"c47f439b","534":"b1893609"}[chunkId] + ".chunk.js";
};